/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
"use strict";

import InitCookieByte from "./modules/cookie-byte";
import InitHeadermenu from "./modules/navigation";
import InitAlertNotice from "./modules/alert-notice";
import InitAccordion from "./modules/accordion";
import InitContactForm from "./modules/contact-form";
import InitConfigurationPage from "./modules/configuration-page";
import InitImageGallery from "./modules/image-gallery";
import InitImageViewer from "./modules/media-viewer";
import InitAnimations from "./customer/animations/animations";
import InitTwemoji from "./customer/twemoji";
import InitServiceSelector from "./customer/service-selector";
import InitNumberAnimation from "./modules/number-animation";
import InitHiddenProfilePictures from "./customer/hidden-profiles";
import InitImageStack from "./customer/image-stack";
import InitAchievements from "./customer/achievements";
import CustomNavigation from "./customer/navigation";
import HeartTimer from "./customer/heart-timer";
import Video from "./customer/video";
import InitBundleGenerator from "./modules/bundle-generator";
import InitFilterSection from "./modules/filters";
import HtmlModal from "./modules/modal";
import InitProtocolGenerator from "./modules/test-protocol-generator";

const siteInitialization = () => {
	const isSupportDashboard = document.querySelector(".headermenu.support") !== null;

	InitTwemoji();
	InitCookieByte();
	InitHeadermenu();
	CustomNavigation.init();
	Video.initAll();
	InitAlertNotice();
	InitAccordion();
	InitContactForm();
	InitAnimations();
	InitConfigurationPage();
	InitBundleGenerator();
	InitFilterSection();
	InitProtocolGenerator();
	HtmlModal.init();

	if (isSupportDashboard) return;

	HeartTimer.init();
	InitAchievements();
	InitHiddenProfilePictures();
	InitNumberAnimation();
	InitServiceSelector();
	InitImageGallery();
	InitImageViewer();
	InitImageStack();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== "loading") siteInitialization();
else document.addEventListener("DOMContentLoaded", siteInitialization);
